"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = exports.MaxRequestSize = void 0;
exports.MaxRequestSize = 2048;
exports.ErrorMessage = {
    maximumRequestSizeExceeded: "Request URL length exceeded the maximum of " + exports.MaxRequestSize
};
//# sourceMappingURL=consts.js.map